import React from 'react';
import styles from './VisibilityDocumentContent.module.scss';
import cn from 'classnames';
import { ReactComponent as ParticipantsIcon } from '../../../../resource/ParticipantsIcon.svg';
import { ReactComponent as CompanyIcon } from '../../../../resource/CompanyIcon.svg';

const enumVisible = {
  COMPANY: 2, // Компания
  PARTICIPANTS: 3, // Участники
};

const iconByType = {
  [enumVisible.COMPANY]: CompanyIcon,
  [enumVisible.PARTICIPANTS]: ParticipantsIcon,
};

const VisibilityDocumentContent = ({ data = [], value, onChange }) => {
  return (
    <div className={styles.root}>
      {data?.map((item) => {
        const IconComponent = iconByType[item.id];

        return (
          <div
            className={cn(styles.content, {
              [styles.active]: value === item.id,
            })}
            onClick={() => onChange(item.id)}
            key={item.id}
          >
            <IconComponent
              style={{ color: value === item.id ? 'white' : '#7D7D7D' }}
            />
            {item.name}
          </div>
        );
      })}
    </div>
  );
};

export default VisibilityDocumentContent;
